import {Injectable} from '@angular/core';
import {BehaviorSubject} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class SharedService {
  private dataSubject = new BehaviorSubject<any>(null);

  private edlInfoSubject = new BehaviorSubject<any>(null);

  public data$ = this.dataSubject.asObservable();
  public edlInfo$ = this.edlInfoSubject.asObservable();

  constructor() {
  }

  isUserLoad(bool: boolean): void {
    this.dataSubject.next(bool);
  }

  getEdlInfoForNavbar(edlInfo: string) {
    this.edlInfoSubject.next(edlInfo);
  }

  clearEdlInfo() {
    this.edlInfoSubject.next(null);
  }
}
